import {Component} from '@angular/core';
import {Store} from '@ngrx/store';
import {ProposalAppState} from '../../store/proposal/reducers/proposal.reducer';
import {
  selectLoading,
  selectPreviewShowRejection,
  selectPreviewShowRetractRejection,
  selectPreviewUsersAllowedToView,
  selectProposalSelected,
  selectRejectionId,
  selectRejectionLoading,
  selectRetractRejectionLoading
} from '../../store/proposal/selectors/proposal.selectors';
import {ProposalSelectedActions, ProposalTileActions} from '../../store/proposal/actions/proposal.actions';
import {Route} from 'src/app/enum/route';
import {Router} from '@angular/router';
import {Offer} from '../../model/offer/offer';
import {OfferType} from '../../enum/offer-type';
import {FormControl, FormGroup} from '@angular/forms';
import {Observable, take} from 'rxjs';
import {PermissionService} from '../../services/permission/permission.service';
import {UserAppState} from '../../store/user/reducers/user.reducer';
import {ProposalService} from '../../services/proposal-service/proposal.service';
import {animate, style, transition, trigger} from '@angular/animations';
import {UserService} from '../../services/user/user.service';
import {selectUserId} from '../../store/user/selectors/user.selectors';
import {SpinnerDialogComponent} from '../dialogs/spinner-dialog/spinner-dialog.component';
import {MatDialog, MatDialogConfig} from '@angular/material/dialog';
import {ProposalUser} from '../../model/proposal/proposalUser';


@Component({
    selector: 'app-proposal-preview',
    templateUrl: './proposal-preview.component.html',
    styleUrls: ['./proposal-preview.component.scss'],
    animations: [
        trigger('rejectionBox', [
            transition(':enter', [
                style({ opacity: 0, marginBottom: '-15rem' }),
                animate('200ms', style({ opacity: 1, marginBottom: 0 })),
            ]),
            transition(':leave', [
                animate('200ms', style({ opacity: 0, marginBottom: '-15rem' }))
            ])
        ]),
        //prevents triggering animation on first preview load
        trigger('empty', [
            transition(':enter', [])
        ]),
        trigger('buttonsContainer', [
            transition(':enter', [
                style({ opacity: 0 }),
                animate('200ms', style({ opacity: 1 })),
            ]),
            transition(':leave', [
                animate('200ms', style({ opacity: 0 }))
            ])
        ]),
    ],
    standalone: false
})
export class ProposalPreview{
  Route = Route;
  showRejectionReason: boolean;
  proposal$ = this.proposalStore.select(selectProposalSelected);
  usersAllowedToView$ = this.proposalStore.select(selectPreviewUsersAllowedToView);
  loading$ = this.proposalStore.select(selectLoading);
  rejectionId$ = this.proposalStore.select(selectRejectionId);
  showRetractRejection$ = this.proposalStore.select(selectPreviewShowRetractRejection);
  showRejection$ = this.proposalStore.select(selectPreviewShowRejection);
  activeUserId$ = this.userStore.select(selectUserId);

  formGroup = new FormGroup({
    rejectionReason: new FormControl('')
  });

  disablePartnerInfo$: Observable<boolean>;

  constructor(public proposalStore: Store<ProposalAppState>,
              public userStore: Store<UserAppState>,
              private readonly router: Router,
              public readonly permissionService: PermissionService,
              private readonly proposalService: ProposalService,
              public readonly userService: UserService,
              readonly dialog: MatDialog,
  ) {
  }

  ngOnInit() {
    this.disablePartnerInfo$ = this.proposalService.checkPartnerInfo(this.proposal$);
  }

  closeDetails() {
    this.proposalStore.dispatch(ProposalSelectedActions.deselect());
  }

  navigateToCreateOffer(id) {
    this.router.navigate(['/' + Route.CREATE_OFFER, id]).then();
  }

  showRejectionReasonField() {
    this.showRejectionReason = !this.showRejectionReason;
  }

  updateRejectionReason(rejectionId) {
    this.proposalStore.select(selectRejectionLoading)
      .subscribe((rejectionLoading: boolean) => {
        if (rejectionLoading) {
          this.openSpinnerDialog();
        } else {
          this.dialog.closeAll();
        }
      });
    let rejectionOffer: Offer = new Offer();
    rejectionOffer.offerType = OfferType.REJECTION;
    rejectionOffer.rejectionText = this.formGroup.value.rejectionReason;
    let proposalCreator = new ProposalUser();
    this.activeUserId$.pipe().subscribe((userId) => proposalCreator.id = userId);
    rejectionOffer.creator = proposalCreator;
    this.proposal$.pipe(take(1)).subscribe((proposal) => {
      rejectionOffer.proposalId = proposal.proposalInformation.id;
      this.proposalStore.dispatch(ProposalTileActions.reject({rejectionId, rejectionOffer}));
    });
    this.closeDetails();
  }

  retractRejection(rejectionId: string, proposalId: string) {
    this.proposalStore.select(selectRetractRejectionLoading)
      .subscribe((retractRejectionLoading: boolean) => {
        if (retractRejectionLoading) {
          this.openSpinnerDialog();
        } else {
          this.dialog.closeAll();
        }
      });
    this.proposal$.pipe(take(1)).subscribe(() => this.proposalStore.dispatch(ProposalTileActions.retractRejection({rejectionId: rejectionId, proposalId: proposalId})));
    this.closeDetails();
  }

  deselectProposal() {
    this.proposalStore.dispatch(ProposalSelectedActions.deselect());
  }

  openSpinnerDialog() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.data = {
      title: '',
    };
    this.dialog.open(SpinnerDialogComponent, dialogConfig);
  }

}
